import angular from 'angular';

const module = angular.module('whyline.directives.preventSpaces', []);

const preventSpaces = () => {
  return {
    restrict: 'A',
    link: (scope, element) => {
      element.bind('keydown', function(e) {
        const key = (e.which) ? e.which : e.keyCode;
        if (key === 32) {
            e.preventDefault();
        }
      });
    }
  };
};
module.exports = module.directive('preventSpaces', preventSpaces);
